// src/components/books/CategoryPickerModal.jsx
import React from 'react';
import { Modal } from './BooksSharedUI.jsx';

export function CategoryPickerModal({
  isOpen,
  onClose,
  onSelect,
  categories = [],
  currentCategoryId = null,
  currentCategoryName = '',
}) {
  if (!isOpen) return null;

  const handlePick = (cat) => {
    onSelect?.(cat.id, cat.name);
    onClose?.();
  };

  const handleClear = () => {
    onSelect?.(null, '');
    onClose?.();
  };

  return (
    <Modal
      isOpen
      onClose={onClose}
      title="انتخاب دسته‌بندی"
      size="md"
      footer={
        <>
          <button
            type="button"
            className="bks-btn bks-btn-ghost"
            onClick={handleClear}
          >
            🚫 بدون دسته‌بندی
          </button>
          <button
            type="button"
            className="bks-btn bks-btn-ghost"
            onClick={onClose}
          >
            انصراف
          </button>
        </>
      }
    >
      {categories.length === 0 ? (
        <div style={{
          padding: '32px 16px',
          textAlign: 'center',
          color: '#64748b',
          lineHeight: 1.9,
        }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>📂</div>
          <div style={{ fontWeight: 700, color: '#334155', marginBottom: 6 }}>
            هنوز دسته‌بندی‌ای تعریف نشده است
          </div>
          <div style={{ fontSize: '0.85rem' }}>
            از مدیر سیستم بخواهید دسته‌بندی‌ها را در پنل مدیریت تعریف کند.
            <br />
            در حال حاضر می‌توانید بدون دسته‌بندی ادامه دهید.
          </div>
        </div>
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
            gap: 10,
            padding: '4px 0',
          }}
        >
          {categories.map((cat) => {
            const isActive = String(currentCategoryId || '') === String(cat.id)
              || (!currentCategoryId && currentCategoryName && cat.name === currentCategoryName);
            return (
              <button
                key={cat.id}
                type="button"
                onClick={() => handlePick(cat)}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: 6,
                  padding: '14px 12px',
                  borderRadius: 12,
                  border: isActive
                    ? '2px solid #4f46e5'
                    : '1.5px solid #e2e8f0',
                  background: isActive ? '#eef2ff' : '#ffffff',
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  textAlign: 'right',
                  transition: 'all 0.15s ease',
                  position: 'relative',
                  boxShadow: isActive
                    ? '0 4px 14px rgba(79,70,229,0.18)'
                    : '0 1px 3px rgba(0,0,0,0.04)',
                }}
                onMouseEnter={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.borderColor = '#a5b4fc';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.borderColor = '#e2e8f0';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }
                }}
              >
                <div style={{
                  fontSize: '1.4rem',
                  lineHeight: 1,
                  marginBottom: 2,
                }}>
                  🎯
                </div>
                <div style={{
                  fontWeight: 800,
                  fontSize: '0.9rem',
                  color: isActive ? '#3730a3' : '#1e293b',
                  lineHeight: 1.4,
                }}>
                  {cat.name}
                </div>
                {isActive && (
                  <div style={{
                    position: 'absolute',
                    top: 8,
                    left: 8,
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                    background: '#4f46e5',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 11,
                    fontWeight: 800,
                  }}>✓</div>
                )}
              </button>
            );
          })}
        </div>
      )}
    </Modal>
  );
}